import React from 'react';
import { observer } from 'mobx-react';

import { ReservationModel } from 'shared/models';

import './styles.scss';

type PropsType = {
    reservation: ReservationModel;
    style?: React.CSSProperties;
};

export const UiReservationPickerReservation = observer(function UiReservationPickerReservation({ reservation, style }: PropsType) {
    return (
        <div className={'ui-new-reservation-picker-reservation'} style={style}>
            <div className='ui-new-reservation-picker-reservation__time'>{reservation.startAtDate.format('HH:mm')} - {reservation.endAtDate.format('HH:mm')}</div>
            <div className='ui-new-reservation-picker-reservation__user'>{reservation.user.previewName}</div>
        </div>
    );
});
